// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__19opy","header":"ReportDetails_header__3JQrk","title":"ReportDetails_title__7W3tt","left":"ReportDetails_left__3GTbq"};